import * as types from "./types";

export default {
  [types.MUTATE_SET_PAGE_TITLE]: (state, payload) => {
    state.pageTitle = payload;
  },
  [types.MUTATE_SET_COLLAPSE]: (state, payload) => {
    state.collapse = payload;
  },
  [types.MUTATE_SET_OVERLAY]: (state, payload) => {
  	state.overlay = payload;
  }
};
